import {
  FormControl,
  InputLabel,
  ListItemIcon,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { languageOptions } from "../../utils/Items";
import { useStyles } from "./SelectLanguageStyles";

const SelectLanguage = () => {
  const { t, BundleKey, changeLanguage, language } = useTranslation();
  const classes = useStyles();
  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      size="small"
    >
      <InputLabel>{t(BundleKey.LANG)}</InputLabel>
      <Select
        labelId="demo-simple-select-outlined-label"
        id="demo-simple-select-outlined"
        onChange={(e: any) => changeLanguage(e.target.value)}
        value={language}
        style={{ backgroundColor: "#fff" }}
        label={t(BundleKey.LANG)}
      >
        {languageOptions.map((item) => (
          <MenuItem value={item.id} key={item.id}>
            <ListItemIcon>
              <img src={item.iconUrl} alt="translation" />
            </ListItemIcon>
            <Typography variant="inherit">{t(item.bundleName)}</Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectLanguage;
